import MakePayment from '../../../../banking/components/cards/make-payment/MakePayment';

const MakePaymentScreen = () => {
    return <MakePayment />;
};

export default MakePaymentScreen;
